import { OP, STATUS } from "../../constant";

const INITIAL_STATE = {
  // ------- api initial-------- //
  apiListStatus: STATUS.DEFAULT,
  apiListResult: null,
  apiListErrorMessage: "",

  apiDetailsStatus: STATUS.DEFAULT,
  apiDetailsResult: null,
  apiDetailsErrorMessage: "",

  viewApiStatus: STATUS.DEFAULT,
  viewApiResult: null,
  viewApiErrorMessage: "",

  activateApiStatus: STATUS.DEFAULT,
  activateApiResult: null,
  activateApiErrorMessage: "",

  deactivateApiStatus: STATUS.DEFAULT,
  deactivateApiResult: null,
  deactivateApiErrorMessage: "",

  approveApiStatus: STATUS.DEFAULT,
  approveApiResult: null,
  approveApiErrorMessage: "",

  rejectApiStatus: STATUS.DEFAULT,
  rejectApiResult: null,
  rejectApiErrorMessage: "",

  getPartnerPropertiesStatus: STATUS.DEFAULT,
  getPartnerPropertiesResult: null,
  getPartnerPropertiesErrorMessage: "",

  createPartnerPropertyStatus: STATUS.DEFAULT,
  createPartnerPropertyResult: null,
  createPartnerPropertyErrorMessage: "",

  updatePartnerPropertyStatus: STATUS.DEFAULT,
  updatePartnerPropertyResult: null,
  updatePartnerPropertyErrorMessage: "",

  updateFspCodeStatus: STATUS.DEFAULT,
  updateFspCodeResult: null,
  updateFspCodeErrorMessage: "",

  updateOutboundCredentialsStatus: STATUS.DEFAULT,
  updateOutboundCredentialsResult: null,
  updateOutboundCredentialsErrorMessage: "",

  downloadKeyStatus: STATUS.DEFAULT,
  downloadKeyResult: null,
  downloadKeyErrorMessage: "",
};

const apiReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    // *------- > api list reduces
    case OP.API_LIST_LOADING:
      return {
        ...state,
        apiListStatus: STATUS.LOADING,
      };
    case OP.API_LIST_SUCCESS:
      return {
        ...state,
        apiListStatus: STATUS.SUCCESS,
        apiListResult: payload,
        apiListErrorMessage: "",
      };
    case OP.API_LIST_FAILURE:
      return {
        ...state,
        apiListStatus: STATUS.ERROR,
        apiListResult: null,
        apiListErrorMessage: payload,
      };
    case OP.API_LIST_RESET:
      return {
        ...state,
        apiListStatus: STATUS.DEFAULT,
        apiListResult: null,
        apiListErrorMessage: "",
      };

    // *-------- > api details reducers
    case OP.API_DETAILS_LOADING:
      return {
        ...state,
        apiDetailsStatus: STATUS.LOADING,
      };
    case OP.API_DETAILS_SUCCESS:
      return {
        ...state,
        apiDetailsStatus: STATUS.SUCCESS,
        apiDetailsResult: payload,
        apiDetailsErrorMessage: "",
      };
    case OP.API_DETAILS_FAILURE:
      return {
        ...state,
        apiDetailsStatus: STATUS.ERROR,
        apiDetailsResult: null,
        apiDetailsErrorMessage: payload,
      };
    case OP.API_DETAILS_RESET:
      return {
        ...state,
        apiDetailsStatus: STATUS.DEFAULT,
        apiDetailsResult: null,
        apiDetailsErrorMessage: "",
      };

    // *-------- > view api reducers
    case OP.VIEW_API_LOADING:
      return {
        ...state,
        viewApiStatus: STATUS.LOADING,
      };
    case OP.VIEW_API_SUCCESS:
      return {
        ...state,
        viewApiStatus: STATUS.SUCCESS,
        viewApiResult: payload,
        viewApiErrorMessage: "",
      };
    case OP.VIEW_API_FAILURE:
      return {
        ...state,
        viewApiStatus: STATUS.ERROR,
        viewApiResult: null,
        viewApiErrorMessage: payload,
      };
    case OP.VIEW_API_RESET:
      return {
        ...state,
        viewApiStatus: STATUS.DEFAULT,
        viewApiResult: null,
        viewApiErrorMessage: "",
      };

    // *-------- > activate api reducers
    case OP.ACTIVATE_API_LOADING:
      return {
        ...state,
        activateApiStatus: STATUS.LOADING,
      };
    case OP.ACTIVATE_API_SUCCESS:
      return {
        ...state,
        activateApiStatus: STATUS.SUCCESS,
        activateApiResult: payload,
        activateApiErrorMessage: "",
      };
    case OP.ACTIVATE_API_FAILURE:
      return {
        ...state,
        activateApiStatus: STATUS.ERROR,
        activateApiResult: null,
        activateApiErrorMessage: payload,
      };
    case OP.ACTIVATE_API_RESET:
      return {
        ...state,
        activateApiStatus: STATUS.DEFAULT,
        activateApiResult: null,
        activateApiErrorMessage: "",
      };

    // *-------- > deactivate api reducers
    case OP.DEACTIVATE_API_LOADING:
      return {
        ...state,
        deactivateApiStatus: STATUS.LOADING,
      };
    case OP.DEACTIVATE_API_SUCCESS:
      return {
        ...state,
        deactivateApiStatus: STATUS.SUCCESS,
        deactivateApiResult: payload,
        deactivateApiErrorMessage: "",
      };
    case OP.DEACTIVATE_API_FAILURE:
      return {
        ...state,
        deactivateApiStatus: STATUS.ERROR,
        deactivateApiResult: null,
        deactivateApiErrorMessage: payload,
      };
    case OP.DEACTIVATE_API_RESET:
      return {
        ...state,
        deactivateApiStatus: STATUS.DEFAULT,
        deactivateApiResult: null,
        deactivateApiErrorMessage: "",
      };

    // *-------- >approve Api reducers
    case OP.APPROVE_API_LOADING:
      return {
        ...state,
        approveApiStatus: STATUS.LOADING,
      };
    case OP.APPROVE_API_SUCCESS:
      return {
        ...state,
        approveApiStatus: STATUS.SUCCESS,
        approveApiResult: payload,
        approveApiErrorMessage: "",
      };
    case OP.APPROVE_API_FAILURE:
      return {
        ...state,
        approveApiStatus: STATUS.ERROR,
        approveApiResult: null,
        approveApiErrorMessage: payload,
      };
    case OP.APPROVE_API_RESET:
      return {
        ...state,
        approveApiStatus: STATUS.DEFAULT,
        approveApiResult: null,
        approveApiErrorMessage: "",
      };

    // *-------- >reject Api reducers
    case OP.REJECT_API_LOADING:
      return {
        ...state,
        rejectApiStatus: STATUS.LOADING,
      };
    case OP.REJECT_API_SUCCESS:
      return {
        ...state,
        rejectApiStatus: STATUS.SUCCESS,
        rejectApiResult: payload,
        rejectApiErrorMessage: "",
      };
    case OP.REJECT_API_FAILURE:
      return {
        ...state,
        rejectApiStatus: STATUS.ERROR,
        rejectApiResult: null,
        rejectApiErrorMessage: payload,
      };
    case OP.REJECT_API_RESET:
      return {
        ...state,
        rejectApiStatus: STATUS.DEFAULT,
        rejectApiResult: null,
        rejectApiErrorMessage: "",
      };

    // *-------- >get partner properties
    case OP.GET_PARTNER_PROPERTIES_LOADING:
      return {
        ...state,
        getPartnerPropertiesStatus: STATUS.LOADING,
      };
    case OP.GET_PARTNER_PROPERTIES_SUCCESS:
      return {
        ...state,
        getPartnerPropertiesStatus: STATUS.SUCCESS,
        getPartnerPropertiesResult: payload,
        getPartnerPropertiesErrorMessage: "",
      };
    case OP.GET_PARTNER_PROPERTIES_FAILURE:
      return {
        ...state,
        getPartnerPropertiesStatus: STATUS.ERROR,
        getPartnerPropertiesResult: null,
        getPartnerPropertiesErrorMessage: payload,
      };
    case OP.GET_PARTNER_PROPERTIES_RESET:
      return {
        ...state,
        getPartnerPropertiesStatus: STATUS.DEFAULT,
        getPartnerPropertiesResult: null,
        getPartnerPropertiesErrorMessage: "",
      };

    // *-------- > create partner property
    case OP.CREATE_PARTNER_PROPERTY_LOADING:
      return {
        ...state,
        createPartnerPropertyStatus: STATUS.LOADING,
      };
    case OP.CREATE_PARTNER_PROPERTY_SUCCESS:
      return {
        ...state,
        createPartnerPropertyStatus: STATUS.SUCCESS,
        createPartnerPropertyResult: payload,
        createPartnerPropertyErrorMessage: "",
      };
    case OP.CREATE_PARTNER_PROPERTY_FAILURE:
      return {
        ...state,
        createPartnerPropertyStatus: STATUS.ERROR,
        createPartnerPropertyResult: null,
        createPartnerPropertyErrorMessage: payload,
      };
    case OP.CREATE_PARTNER_PROPERTY_RESET:
      return {
        ...state,
        createPartnerPropertyStatus: STATUS.DEFAULT,
        createPartnerPropertyResult: null,
        createPartnerPropertyErrorMessage: "",
      };

    // *-------- > update partner property
    case OP.UPDATE_PARTNER_PROPERTY_LOADING:
      return {
        ...state,
        updatePartnerPropertyStatus: STATUS.LOADING,
      };
    case OP.UPDATE_PARTNER_PROPERTY_SUCCESS:
      return {
        ...state,
        updatePartnerPropertyStatus: STATUS.SUCCESS,
        updatePartnerPropertyResult: payload,
        updatePartnerPropertyErrorMessage: "",
      };
    case OP.UPDATE_PARTNER_PROPERTY_FAILURE:
      return {
        ...state,
        updatePartnerPropertyStatus: STATUS.ERROR,
        updatePartnerPropertyResult: null,
        updatePartnerPropertyErrorMessage: payload,
      };
    case OP.UPDATE_PARTNER_PROPERTY_RESET:
      return {
        ...state,
        updatePartnerPropertyStatus: STATUS.DEFAULT,
        updatePartnerPropertyResult: null,
        updatePartnerPropertyErrorMessage: "",
      };

    // *-------- > update fsp code
    case OP.UPDATE_FSP_CODE_LOADING:
      return {
        ...state,
        updateFspCodeStatus: STATUS.LOADING,
      };
    case OP.UPDATE_FSP_CODE_SUCCESS:
      return {
        ...state,
        updateFspCodeStatus: STATUS.SUCCESS,
        updateFspCodeResult: payload,
        updateFspCodeErrorMessage: "",
      };
    case OP.UPDATE_FSP_CODE_FAILURE:
      return {
        ...state,
        updateFspCodeStatus: STATUS.ERROR,
        updateFspCodeResult: null,
        updateFspCodeErrorMessage: payload,
      };
    case OP.UPDATE_FSP_CODE_RESET:
      return {
        ...state,
        updateFspCodeStatus: STATUS.DEFAULT,
        updateFspCodeResult: null,
        updateFspCodeErrorMessage: "",
      };

    // *-------- > update outbound credentials
    case OP.UPDATE_OUTBOUND_CREDENTIALS_LOADING:
      return {
        ...state,
        updateOutboundCredentialsStatus: STATUS.LOADING,
      };
    case OP.UPDATE_OUTBOUND_CREDENTIALS_SUCCESS:
      return {
        ...state,
        updateOutboundCredentialsStatus: STATUS.SUCCESS,
        updateOutboundCredentialsResult: payload,
        updateOutboundCredentialsErrorMessage: "",
      };
    case OP.UPDATE_OUTBOUND_CREDENTIALS_FAILURE:
      return {
        ...state,
        updateOutboundCredentialsStatus: STATUS.ERROR,
        updateOutboundCredentialsResult: null,
        updateOutboundCredentialsErrorMessage: payload,
      };
    case OP.UPDATE_OUTBOUND_CREDENTIALS_RESET:
      return {
        ...state,
        updateOutboundCredentialsStatus: STATUS.DEFAULT,
        updateOutboundCredentialsResult: null,
        updateOutboundCredentialsErrorMessage: "",
      };

    // *-------- > download key
    case OP.DOWNLOAD_KEY_LOADING:
      return {
        ...state,
        downloadKeyStatus: STATUS.LOADING,
      };
    case OP.DOWNLOAD_KEY_SUCCESS:
      return {
        ...state,
        downloadKeyStatus: STATUS.SUCCESS,
        downloadKeyResult: payload,
        downloadKeyErrorMessage: "",
      };
    case OP.DOWNLOAD_KEY_FAILURE:
      return {
        ...state,
        downloadKeyStatus: STATUS.ERROR,
        downloadKeyResult: null,
        downloadKeyErrorMessage: payload,
      };
    case OP.DOWNLOAD_KEY_RESET:
      return {
        ...state,
        downloadKeyStatus: STATUS.DEFAULT,
        downloadKeyResult: null,
        downloadKeyErrorMessage: "",
      };

    default:
      return state;
  }
};

export default apiReducer;
